import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const ValuesInputContainerStyles = styled(FlexContainer)`
  margin-top: 1rem;
`;
